// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// 1) Importar i18n para que se inicialice antes de montar <App />
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
